export default "__VITE_ASSET__Pl95arE5__"